import type {ReactElement} from 'react';
import React from 'react';
import {BaseListMobileColorPanel} from '@Panels/poster-editor-item-list-panel/components/base-list-mobile-color-panel';
import {useUpdateEffect} from 'ahooks';
import type {FillTypes} from '@PosterWhiteboard/classes/fill.class';
import type {RGBA} from '@Utils/color.util';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetSelectedSlideId} from '@Hooks/poster-editor/useGetSelectedSlideId';
import {useGetKeyFromFillOfListOfActiveSlideItem} from '@Hooks/poster-editor/useGetKeyFromFillOfListOfActiveSlideItem';
import {useGetKeyFromListOfActiveSlideItem} from '@Hooks/poster-editor/useGetKeyFromListOfActiveSlideItem';

interface TextSlideListColorPanelProps {
  panelId: string;
  onClose(): void;
  onBack(): void;
}

export function TextSlideListColorPanel({...props}: TextSlideListColorPanelProps): ReactElement | null {
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeSlideUID = useGetSelectedSlideId();
  const activeSlide = activeSlideUID && activeItem?.isSlideshow() ? activeItem.getSelectedSlide() : null;
  const fillColor = useGetKeyFromFillOfListOfActiveSlideItem('fillColor');
  const fillType = useGetKeyFromFillOfListOfActiveSlideItem('fillType');
  const listType = useGetKeyFromListOfActiveSlideItem('type');
  const listStyle = useGetKeyFromListOfActiveSlideItem('style');
  const listWidth = useGetKeyFromListOfActiveSlideItem('width');

  useUpdateEffect((): void => {
    props.onClose();
  }, [activeItemId]);

  useUpdateEffect((): void => {
    props.onClose();
  }, [activeSlideUID]);

  if (!activeItem?.isSlideshow()) {
    return null;
  }

  if (!activeSlide?.isTextSlide() || activeSlideUID === undefined) {
    return null;
  }

  if (!fillColor || fillType === undefined || listType === undefined || listStyle === undefined || listWidth === undefined) {
    return null;
  }

  const updateFillColor = (fillColor: RGBA[], undoable = true): void => {
    void activeItem.updateSlideFromObject(
      activeSlide.uid,
      {
        list: {
          fill: {
            fillColor,
          },
        },
      },
      {
        undoable,
      }
    );
  };

  const onChangeType = (newType: FillTypes): void => {
    void activeItem.updateSlideFromObject(activeSlideUID, {
      list: {
        fill: {
          fillType: newType,
          fillColor: activeSlide.list.fill.getColorForNewType(newType),
        },
      },
    });
  };

  return (
    <BaseListMobileColorPanel
      panelId={props.panelId}
      listObject={{
        type: listType,
        fill: {
          fillType: fillType,
          fillColor: fillColor,
        },
        style: listStyle,
        width: listWidth,
      }}
      onChangeColor={updateFillColor}
      onChangeFillType={onChangeType}
      onClose={(): void => {
        props.onClose();
      }}
      onBack={(): void => {
        props.onBack();
      }}
    />
  );
}
